module.exports = __webpack_public_path__ + "img/COM-i-2-II.c03d09c7.png";